import { LookupModel } from "../shared/lookup.model";
import { ERPConfigModel } from "./responses/erp-config.response.model";
import { ErpType } from "app/shared/enums";


export class ERPProviderModel extends LookupModel<ErpType> {
    oauthUrl?: string;
    description?: string;
    erpCredential?: ERPConfigModel;
    has_detail = false;
    has_upload = false;
    allow_add_organization = true;
    show_in_integration = true; // Controls visibility in ERP integration/config page

    constructor(init?: Partial<ERPProviderModel>) {
        super();
        
        if (init) {
            Object.assign(this, init);
        }

        switch(this.value) {
            case ErpType.XERO:
                this.description = 'Xero cloud accounting. Connect via OAuth to sync AP invoices and payments.';
                break;
            case ErpType.QUICKBOOKS:
                this.description = 'QuickBooks Online. Connect via OAuth to sync AP invoices and payments.';
                break;
            case ErpType.VIEWPOINT:
                this.description = 'Trimble Viewpoint Vista ERP. Pair via desktop app to sync AP data.';
                break;
            case ErpType.TECHONE:
                this.description = 'Enterprise ERP for government and large organizations. Connect to sync AP data.';
                break;
            case ErpType.MYOB:
                this.description = 'Australian accounting software. Connect to sync AP invoices and payments.';
                break;
            case ErpType.SAGE:
                this.description = 'Sage Accounting — cloud accounting for small businesses (UK, IE, US, CA, FR, ES, DE, UAE). Connect via OAuth to sync AP data.';
                break;
            case ErpType.D365:
                this.description = 'Microsoft Dynamics 365 Business Central. Connect via OAuth to sync AP data.';
                break;
            case ErpType.ACUMATICA:
                this.description = 'Acumatica Cloud ERP (US). Connect to sync AP invoices and payments.';
                break;
            case ErpType.IMPORTED:
                this.description = 'Upload AP data from any ERP. Import CSV, Excel, or PDF files to sync invoices and payments.';
                break;
            default:
                break;
        }

        if (!this.erpCredential) {
            this.erpCredential = new ERPConfigModel();
        }

        if ((this.value === ErpType.XERO || this.value === ErpType.VIEWPOINT || this.value === ErpType.QUICKBOOKS
            || this.value === ErpType.TECHONE || this.value === ErpType.MYOB || this.value === ErpType.SAGE
            || this.value === ErpType.D365 || this.value === ErpType.ACUMATICA) && this.status !== 'NONE') {
            this.has_detail = true;
        }

        if (this.value === ErpType.VIEWPOINT) {
            this.allow_add_organization = false;
        }
    }
}

export class ERPLoadingModel {
    type?: ErpType;
    isLoading?: boolean;
    organizationId?: string;
}

export class ERPUploadModel {
    type?: ErpType;
    file?: File;
}